<template>
  <v-layout column class="pagemargin page">
    <!--Select games-->
    <!--Title-->
    <v-toolbar color="secondary" v-if="!gameHidden">
      <v-layout wrap>
        <v-flex
          xs12
          sm12
          :class="{
              'text-xs-center': $vuetify.breakpoint.smAndDown
            }"
        >
          <span class="page-title font-weight-thin white--text">Choose games for comparison</span>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-progress-linear
      v-if="!gameHidden"
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="primary"
    ></v-progress-linear>

    <h3>Select one game below to print a report or two games to print a comparison report</h3>

    <!--First select-->
    <v-layout row wrap align-center v-if="!gameHidden" class="selected-container">
      <v-flex xs12 md6>
        <v-select
          v-model="selected"
          :items="games"
          item-text="gameName"
          item-value="id"
          attach
          label="Select first game"
          name="Selected"
          class="font-weight-thin"
          @input="selectFirstGame(selected)"
          style="padding: 0px 5% 0px 5% !important"
          data-vv-rules="required"
          v-validate="'required'"
          :error-messages="errors.collect('selected')"
        ></v-select>
        <i v-show="errors.has('selected')" class="fa fa-warning"></i>
        <span v-show="errors.has('selected')" class="help is-danger">{{ errors.first('selected') }}</span>
      </v-flex>
      <!--Second select-->
      <v-flex xs12 md6>
        <v-select
          v-model="secondselected"
          :items="games"
          item-text="gameName"
          item-value="id"
          attach
          label="Select second game"
          name="SecondSelected"
          class="font-weight-thin"
          @input="selectSecondGame(secondselected)"
          style="padding: 0px 5% 0px 5% !important"
          data-vv-rules="required"
          v-validate="'required'"
          :error-messages="errors.collect('secondselected')"
        ></v-select>
        <i v-show="errors.has('secondselected')" class="fa fa-warning"></i>
        <span v-show="errors.has('secondselected')" class="help is-danger"></span>
      </v-flex>

      <!-- Go button-->
      <v-flex xs12 md12>
        <v-btn
          v-if="!loading"
          color="primary"
          :disabled="errors.any()"
          @click="loading = true, validateBeforeSubmit()"
          round
          class="actionbutton"
        >GO</v-btn>
      </v-flex>
    </v-layout>
    <!-- fix loading-->

    <!--/Select games-->
    

    <!--
    <v-layout row wrap v-if="gameHidden">
      <v-flex md12>
        <v-toolbar color="secondary">
          <v-toolbar-title class="font-weight-thin white--text">
            Comparison between
            <strong>{{gName}}</strong> and
            <strong>{{secondGName}}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="openComparisonPrint()" dark right large class="icons8-pdf"></v-icon>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <div id="printMe">
      <v-layout row wrap class="mt-3 pa-3" v-if="gameHidden">
        <v-flex xs12 md6 class="test-print">
          <h1>{{gName}}</h1>
          <h3>
            Top 5 Sponsors by Air Time
            <span>
              <v-icon @click="printFirstGame()" light right large class="icons8-pdf"></v-icon>
            </span>
          </h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SponsorsByAirTime />
        </v-flex>
        <v-flex xs12 md6 id="second-report">
          <h1>{{secondGName}}</h1>
          <h3>
            Top 5 Sponsors by Air Time
            <span>
              <v-icon @click="printSecondGame()" light right large class="icons8-pdf"></v-icon>
            </span>
          </h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByAirTime />
        </v-flex>
        <v-flex xs12 md6>
          <h1 class="report-titles">{{gName}}</h1>
          <h3>Top 5 Locations by Air Time - {{gName}}</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <LocationsByAirTime />
        </v-flex>
        <v-flex xs12 md6>
          <h1 class="report-titles">{{secondGName}}</h1>
          <h3>Top 5 Locations by Air Time</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondLocationsByAirTime />
        </v-flex>
        <v-flex xs12 md6>
          <h1 class="report-titles">{{gName}}</h1>
          <h3>Top 5 by Ad Frequency - {{gName}}</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SponsorsByAdFrequency />
        </v-flex>
        <v-flex xs12 md6>
          <h1 class="report-titles">{{secondGName}}</h1>
          <h3>Top 5 by Ad Frequency</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByAdFrequency />
        </v-flex>
        <v-flex xs12 md6 id="first-report">
          <h1 class="report-titles">{{gName}}</h1>
          <h3>Top 5 Sponsors by Dwell Time - {{gName}}</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SponsorsByDwellTime />
        </v-flex>
        <v-flex xs12 md6>
          <h1 class="report-titles">{{secondGName}}</h1>
          <h3>Top 5 Sponsors by Dwell Time</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByDwellTime />
        </v-flex>
      </v-layout>
    </div>
    -->
  
    <div style="height: 50px !important"></div>
    <!-- bottom navigation -->
    <v-bottom-nav app :active.sync="bottomNav" :value="true" fixed color="white">
     <!-- <v-btn
        color="primary"
        flat
        value="back"
        class="back-btn"
        v-if="gameHidden"
        v-on:click="gameHidden = false;"
      >
        <span>Back</span>
        <v-icon>icons8-sort-left</v-icon>
      </v-btn>-->
      <v-btn color="primary" value="home" flat v-on:click="gameHidden = false;">
        <span>Games</span>
        <v-icon>icons8-stadium</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
import SponsorsByAirTime from "@/components/charts/SponsorsByAirTime.vue";
import LocationsByAirTime from "@/components/charts/LocationsByAirTime.vue";
import SponsorsByAdFrequency from "@/components/charts/SponsorsByAdFrequency.vue";
import SponsorsByDwellTime from "@/components/charts/SponsorsByDwellTime.vue";

import SecondSponsorsByAirTime from "@/components/comparisonCharts/SecondSponsorsByAirTime.vue";
import SecondLocationsByAirTime from "@/components/comparisonCharts/SecondLocationsByAirTime.vue";
import SecondSponsorsByAdFrequency from "@/components/comparisonCharts/SecondSponsorsByAdFrequency.vue";
import SecondSponsorsByDwellTime from "@/components/comparisonCharts/SecondSponsorsByDwellTime.vue";

import Vue from "vue";
import { mapState } from "vuex";

export default {
  name: "ComparisonReportView",
  components: {
    SponsorsByAirTime,
    LocationsByAirTime,
    SponsorsByAdFrequency,
    SponsorsByDwellTime,
    SecondSponsorsByAirTime,
    SecondLocationsByAirTime,
    SecondSponsorsByAdFrequency,
    SecondSponsorsByDwellTime
  },
  data() {
    return {
      active: null,
      bottomNav: "home",
      games: [],
      portalList: [],
      gameHidden: false,
      selected: "",
      secondselected: "",
      output: null,
      loading: false,
      rules: {
        required: value => !!value || "Required."
      }
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      gameID: state => state.game.gameID,
      secondGameID: state => state.game.secondGameID,
      gName: state => state.report.gameName,
      secondGName: state => state.report.secondGameName,
      gID: state => state.report.gameID,
      secondGID: state => state.report.secondGameID
    })
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    loading(val) {
      if (!val) return;
      setTimeout(() => (this.loading = false), 3000);
    }
  },
  methods: {
    validateBeforeSubmit() {
      //console.log("1st: " + this.selected + "\n2nd: " + this.secondselected);
      if(this.secondselected === "" && this.selected != ""){
        this.$router.push("/viewfirstgameprintreport");
        this.selected = "";
      }
      else if(this.secondselected != "" && this.selected === ""){
        this.$router.push("/viewfirstgameprintreport");
        this.secondselected = "";
      }
      else if(this.secondselected != "" && this.selected != ""){
        this.$router.push("/viewprintreport");
        this.selected = "";
        this.secondselected = "";
      }
  
      // this.$validator.validateAll().then(result => {
      //   if (result) {
      //     this.gameHidden = true;
      //     // console.log("Form Submitted!");
      //     return;
      //   }
      //   this.gameHidden = false;
      //   // console.log("Correct them errors!");
      // });
    },
    readGames() {
      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    selectFirstGame(gameID) {
      // console.log("Selected: " + gameID);
      this.$store.commit("report/setValue", ["gameID", gameID]);
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
      var i = 0;
      var gameName = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (gameID === this.Documents[i].id) {
          gameName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", ["gameName", gameName]);
        }
      }
      //update table on select
      this.$store.dispatch("clip/getClipsByStatusAndGame", [
        "clips",
        this.portal.active.id,
        this.gID,
        "Draft",
        "clip/setSponByGameResult"
      ]);
    },
    selectSecondGame(secondGameID) {
      // console.log("Second selected: " + secondGameID);
      this.$store.commit("report/setValue", ["secondGameID", secondGameID]);
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.secondGID,
        "Admin/setDocByID"
      ]);
      var i = 0;
      var secondGName = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (secondGameID === this.Documents[i].id) {
          secondGName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", [
            "secondGameName",
            secondGName
          ]);
        }
      }
      // console.log("Second game name: " + this.secondGName);
      //update table on select
      this.$store.dispatch("clip/getClipsByStatusAndGame", [
        "clips",
        this.portal.active.id,
        this.secondGID,
        "Draft",
        "clip/setSecondSponByGameResult"
      ]);
    },
    redirectToPrint() {
      // this.$router.push("/printcomparison");
      this.$htmlToPaper("printMe", () => {
        // console.log("Printing done or got cancelled!");
      });
    },
    openComparisonPrint() {
      this.$store.dispatch(
        "report/sendFirstGameIDandName",
        [this.gID, this.gName],
        "report/setReportData"
      );
      this.$store.dispatch(
        "report/sendSecondGameIDandName",
        [this.secondGID, this.secondGName],
        "report/setReportData"
      );
      this.$router.push("/viewprintreport");
    },
    printFirstGame() {
      this.$store.dispatch(
        "report/sendFirstGameIDandName",
        [this.gID, this.gName],
        "report/setReportData"
      );
      this.$router.push("/viewfirstgameprintreport");
    },
    printSecondGame() {
       this.$store.dispatch(
        "report/sendSecondGameIDandName",
        [this.secondGID, this.secondGName],
        "report/setReportData"
      );
      this.$router.push("/viewsecondgameprintreport");
    }
  },
  mounted() {
    this.readGames();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.selected-container {
  position: relative;
  z-index: 2;
  margin-top: 10%;
}

.comparison-title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.report-titles {
  margin-top: 30px !important;
}

.actionbutton{
  border-radius: 10px !important;
  margin-top: 3% !important;
}
</style>

